// extracted by mini-css-extract-plugin
export default {"title_lg":"title_title_lg__bmqrG","title_md":"title_title_md__84-Zf"};